<template>
    <transition name="fade">
        <div
            v-show="showMengaMenuPage"
            class="container mega-menu-large "
            @mouseover="displayMegaMenu"
            @mouseleave="closeMegaMenu"
        >
            <div
                v-for="(element, i) in headerTopMenuElementModels"
                :key="i"
            >
                <div
                    v-show="i === megaMenuPageDelayed"
                    class="padding-bottom"
                >
                    <mega-menu-page :options="element" />
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import MegaMenuPage from './MegaMenuPage.vue';

export default {
    name: 'MegaMenuLargeScreen',
    components: {
        MegaMenuPage
    },
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        headerTopMenuElementModels: {
            type: Array,
            default() {
                return [];
            }
        },
        isAutenticated: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            showMengaMenuPage: false,
            megaMenuPageDelayed: -1
        };
    },
    watch: {
        isMegaMenuShown() {
            this.setShowMengaMenuPage();
        },
        megaMenuPage() {
            this.setMegaMenuPageDelayed();
        }
    },
    methods: {
        closeMegaMenu() {
            this.$store.dispatch('header/changeHideMegaMenu');
        },
        displayMegaMenu() {
            this.$store.dispatch('header/changeDisplayMegaMenu');
        },
        setShowMengaMenuPage() {
            const self = this;
            setTimeout(() => {
                if (self.$store.state.header.megaMenuState.onTopMenu || self.$store.state.header.megaMenuState.onMegaMenu) {
                    self.showMengaMenuPage = true;
                } else {
                    self.showMengaMenuPage = false;
                }
            }, 600);
        },
        setMegaMenuPageDelayed() {
            const self = this;
            setTimeout(() => {
                if (!self.$store.state.header.megaMenuState.onMegaMenu) {
                    self.megaMenuPageDelayed = self.megaMenuPage;
                }
            }, 500);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header.scss';

.padding-bottom {
    padding-bottom: rem-calc(60px);
}
</style>
